/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FeeRunOut,
  GetOwnerStatementPdfParams,
  HTTPValidationError,
  ListOwnerStatementsParams,
  ListOwnerTransactionsParams,
  MonthIn,
  OwnerTransactionIn,
  OwnerTransactionOut,
  PaginatedOwnerTransactionOut,
  StatementsOut,
  VoidIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listOwnerStatementsResponse200 = {
  data: StatementsOut
  status: 200
}

export type listOwnerStatementsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listOwnerStatementsResponseSuccess = (listOwnerStatementsResponse200) & {
  headers: Headers;
};
export type listOwnerStatementsResponseError = (listOwnerStatementsResponse422) & {
  headers: Headers;
};

export type listOwnerStatementsResponse = (listOwnerStatementsResponseSuccess | listOwnerStatementsResponseError)

export const getListOwnerStatementsUrl = (params: ListOwnerStatementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/owner-accounting/statements?${stringifiedParams}` : `/api/owner-accounting/statements`
}

/**
 * @summary List Owner Statements
 */
export const listOwnerStatements = async (params: ListOwnerStatementsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listOwnerStatementsResponse> => {

  return apiFetch<listOwnerStatementsResponse>(getListOwnerStatementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerStatementsQueryKey = (params?: ListOwnerStatementsParams,) => {
    return [
    `/api/owner-accounting/statements`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOwnerStatementsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerStatements>>, TError = HTTPValidationError>(params: ListOwnerStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerStatements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerStatementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerStatements>>> = ({ signal }) => listOwnerStatements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerStatements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOwnerStatementsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerStatements>>>
export type ListOwnerStatementsQueryError = HTTPValidationError


export function useListOwnerStatements<TData = Awaited<ReturnType<typeof listOwnerStatements>>, TError = HTTPValidationError>(
 params: ListOwnerStatementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerStatements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerStatements>>,
          TError,
          Awaited<ReturnType<typeof listOwnerStatements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerStatements<TData = Awaited<ReturnType<typeof listOwnerStatements>>, TError = HTTPValidationError>(
 params: ListOwnerStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerStatements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerStatements>>,
          TError,
          Awaited<ReturnType<typeof listOwnerStatements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerStatements<TData = Awaited<ReturnType<typeof listOwnerStatements>>, TError = HTTPValidationError>(
 params: ListOwnerStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerStatements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Owner Statements
 */

export function useListOwnerStatements<TData = Awaited<ReturnType<typeof listOwnerStatements>>, TError = HTTPValidationError>(
 params: ListOwnerStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerStatements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnerStatementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type publishOwnerStatementsResponse200 = {
  data: StatementsOut
  status: 200
}

export type publishOwnerStatementsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type publishOwnerStatementsResponseSuccess = (publishOwnerStatementsResponse200) & {
  headers: Headers;
};
export type publishOwnerStatementsResponseError = (publishOwnerStatementsResponse422) & {
  headers: Headers;
};

export type publishOwnerStatementsResponse = (publishOwnerStatementsResponseSuccess | publishOwnerStatementsResponseError)

export const getPublishOwnerStatementsUrl = () => {




  return `/api/owner-accounting/statements/publish`
}

/**
 * @summary Publish Owner Statements
 */
export const publishOwnerStatements = async (monthIn: MonthIn, options?: Parameters<typeof apiFetch>[1]): Promise<publishOwnerStatementsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<publishOwnerStatementsResponse>(getPublishOwnerStatementsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(monthIn)
  }
);}





export const getPublishOwnerStatementsMutationKey = () => ['publishOwnerStatements'] as const;

export const getPublishOwnerStatementsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishOwnerStatements>>, TError,PublishOwnerStatementsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishOwnerStatements>>, TError,PublishOwnerStatementsMutationVariables, TContext> => {

const mutationKey = getPublishOwnerStatementsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishOwnerStatements>>, PublishOwnerStatementsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  publishOwnerStatements(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishOwnerStatementsMutationResult = NonNullable<Awaited<ReturnType<typeof publishOwnerStatements>>>
    export type PublishOwnerStatementsMutationBody = MonthIn
    export type PublishOwnerStatementsMutationError = HTTPValidationError
    export type PublishOwnerStatementsMutationVariables = {data: MonthIn}

    /**
 * @summary Publish Owner Statements
 */
export const usePublishOwnerStatements = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishOwnerStatements>>, TError,PublishOwnerStatementsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishOwnerStatements>>,
        TError,
        PublishOwnerStatementsMutationVariables,
        TContext
      > => {
      return useMutation(getPublishOwnerStatementsMutationOptions(options), queryClient);
    }
    export type getOwnerStatementPdfResponse200 = {
  data: Blob
  status: 200
}

export type getOwnerStatementPdfResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getOwnerStatementPdfResponseSuccess = (getOwnerStatementPdfResponse200) & {
  headers: Headers;
};
export type getOwnerStatementPdfResponseError = (getOwnerStatementPdfResponse422) & {
  headers: Headers;
};

export type getOwnerStatementPdfResponse = (getOwnerStatementPdfResponseSuccess | getOwnerStatementPdfResponseError)

export const getGetOwnerStatementPdfUrl = (ownerId: number,
    params: GetOwnerStatementPdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/owner-accounting/statements/${ownerId}/pdf?${stringifiedParams}` : `/api/owner-accounting/statements/${ownerId}/pdf`
}

/**
 * @summary Get Owner Statement Pdf
 */
export const getOwnerStatementPdf = async (ownerId: number,
    params: GetOwnerStatementPdfParams, options?: Parameters<typeof apiFetch>[1]): Promise<getOwnerStatementPdfResponse> => {

  return apiFetch<getOwnerStatementPdfResponse>(getGetOwnerStatementPdfUrl(ownerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerStatementPdfQueryKey = (ownerId: number,
    params?: GetOwnerStatementPdfParams,) => {
    return [
    `/api/owner-accounting/statements/${ownerId}/pdf`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOwnerStatementPdfQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError = HTTPValidationError>(ownerId: number,
    params: GetOwnerStatementPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerStatementPdfQueryKey(ownerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerStatementPdf>>> = ({ signal }) => getOwnerStatementPdf(ownerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: ownerId !== null && ownerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnerStatementPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerStatementPdf>>>
export type GetOwnerStatementPdfQueryError = HTTPValidationError


export function useGetOwnerStatementPdf<TData = Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError = HTTPValidationError>(
 ownerId: number,
    params: GetOwnerStatementPdfParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerStatementPdf>>,
          TError,
          Awaited<ReturnType<typeof getOwnerStatementPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerStatementPdf<TData = Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError = HTTPValidationError>(
 ownerId: number,
    params: GetOwnerStatementPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerStatementPdf>>,
          TError,
          Awaited<ReturnType<typeof getOwnerStatementPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerStatementPdf<TData = Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError = HTTPValidationError>(
 ownerId: number,
    params: GetOwnerStatementPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Owner Statement Pdf
 */

export function useGetOwnerStatementPdf<TData = Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError = HTTPValidationError>(
 ownerId: number,
    params: GetOwnerStatementPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerStatementPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerStatementPdfQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type runManagementFeesResponse200 = {
  data: FeeRunOut
  status: 200
}

export type runManagementFeesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runManagementFeesResponseSuccess = (runManagementFeesResponse200) & {
  headers: Headers;
};
export type runManagementFeesResponseError = (runManagementFeesResponse422) & {
  headers: Headers;
};

export type runManagementFeesResponse = (runManagementFeesResponseSuccess | runManagementFeesResponseError)

export const getRunManagementFeesUrl = () => {




  return `/api/owner-accounting/fees`
}

/**
 * @summary Run Management Fees
 */
export const runManagementFees = async (monthIn: MonthIn, options?: Parameters<typeof apiFetch>[1]): Promise<runManagementFeesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<runManagementFeesResponse>(getRunManagementFeesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(monthIn)
  }
);}





export const getRunManagementFeesMutationKey = () => ['runManagementFees'] as const;

export const getRunManagementFeesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runManagementFees>>, TError,RunManagementFeesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runManagementFees>>, TError,RunManagementFeesMutationVariables, TContext> => {

const mutationKey = getRunManagementFeesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runManagementFees>>, RunManagementFeesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  runManagementFees(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunManagementFeesMutationResult = NonNullable<Awaited<ReturnType<typeof runManagementFees>>>
    export type RunManagementFeesMutationBody = MonthIn
    export type RunManagementFeesMutationError = HTTPValidationError
    export type RunManagementFeesMutationVariables = {data: MonthIn}

    /**
 * @summary Run Management Fees
 */
export const useRunManagementFees = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runManagementFees>>, TError,RunManagementFeesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runManagementFees>>,
        TError,
        RunManagementFeesMutationVariables,
        TContext
      > => {
      return useMutation(getRunManagementFeesMutationOptions(options), queryClient);
    }
    export type listOwnerTransactionsResponse200 = {
  data: PaginatedOwnerTransactionOut
  status: 200
}

export type listOwnerTransactionsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listOwnerTransactionsResponseSuccess = (listOwnerTransactionsResponse200) & {
  headers: Headers;
};
export type listOwnerTransactionsResponseError = (listOwnerTransactionsResponse422) & {
  headers: Headers;
};

export type listOwnerTransactionsResponse = (listOwnerTransactionsResponseSuccess | listOwnerTransactionsResponseError)

export const getListOwnerTransactionsUrl = (params?: ListOwnerTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/owner-accounting/transactions?${stringifiedParams}` : `/api/owner-accounting/transactions`
}

/**
 * @summary List Owner Transactions
 */
export const listOwnerTransactions = async (params?: ListOwnerTransactionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listOwnerTransactionsResponse> => {

  return apiFetch<listOwnerTransactionsResponse>(getListOwnerTransactionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerTransactionsQueryKey = (params?: ListOwnerTransactionsParams,) => {
    return [
    `/api/owner-accounting/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOwnerTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerTransactions>>, TError = HTTPValidationError>(params?: ListOwnerTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerTransactions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerTransactions>>> = ({ signal }) => listOwnerTransactions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOwnerTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerTransactions>>>
export type ListOwnerTransactionsQueryError = HTTPValidationError


export function useListOwnerTransactions<TData = Awaited<ReturnType<typeof listOwnerTransactions>>, TError = HTTPValidationError>(
 params: undefined |  ListOwnerTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerTransactions>>,
          TError,
          Awaited<ReturnType<typeof listOwnerTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerTransactions<TData = Awaited<ReturnType<typeof listOwnerTransactions>>, TError = HTTPValidationError>(
 params?: ListOwnerTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerTransactions>>,
          TError,
          Awaited<ReturnType<typeof listOwnerTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerTransactions<TData = Awaited<ReturnType<typeof listOwnerTransactions>>, TError = HTTPValidationError>(
 params?: ListOwnerTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerTransactions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Owner Transactions
 */

export function useListOwnerTransactions<TData = Awaited<ReturnType<typeof listOwnerTransactions>>, TError = HTTPValidationError>(
 params?: ListOwnerTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerTransactions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnerTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordOwnerTransactionResponse201 = {
  data: OwnerTransactionOut
  status: 201
}

export type recordOwnerTransactionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type recordOwnerTransactionResponseSuccess = (recordOwnerTransactionResponse201) & {
  headers: Headers;
};
export type recordOwnerTransactionResponseError = (recordOwnerTransactionResponse422) & {
  headers: Headers;
};

export type recordOwnerTransactionResponse = (recordOwnerTransactionResponseSuccess | recordOwnerTransactionResponseError)

export const getRecordOwnerTransactionUrl = () => {




  return `/api/owner-accounting/transactions`
}

/**
 * @summary Record Owner Transaction
 */
export const recordOwnerTransaction = async (ownerTransactionIn: OwnerTransactionIn, options?: Parameters<typeof apiFetch>[1]): Promise<recordOwnerTransactionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<recordOwnerTransactionResponse>(getRecordOwnerTransactionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ownerTransactionIn)
  }
);}





export const getRecordOwnerTransactionMutationKey = () => ['recordOwnerTransaction'] as const;

export const getRecordOwnerTransactionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOwnerTransaction>>, TError,RecordOwnerTransactionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordOwnerTransaction>>, TError,RecordOwnerTransactionMutationVariables, TContext> => {

const mutationKey = getRecordOwnerTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordOwnerTransaction>>, RecordOwnerTransactionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  recordOwnerTransaction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordOwnerTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof recordOwnerTransaction>>>
    export type RecordOwnerTransactionMutationBody = OwnerTransactionIn
    export type RecordOwnerTransactionMutationError = HTTPValidationError
    export type RecordOwnerTransactionMutationVariables = {data: OwnerTransactionIn}

    /**
 * @summary Record Owner Transaction
 */
export const useRecordOwnerTransaction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOwnerTransaction>>, TError,RecordOwnerTransactionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordOwnerTransaction>>,
        TError,
        RecordOwnerTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getRecordOwnerTransactionMutationOptions(options), queryClient);
    }
    export type voidOwnerTransactionResponse200 = {
  data: OwnerTransactionOut
  status: 200
}

export type voidOwnerTransactionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type voidOwnerTransactionResponseSuccess = (voidOwnerTransactionResponse200) & {
  headers: Headers;
};
export type voidOwnerTransactionResponseError = (voidOwnerTransactionResponse422) & {
  headers: Headers;
};

export type voidOwnerTransactionResponse = (voidOwnerTransactionResponseSuccess | voidOwnerTransactionResponseError)

export const getVoidOwnerTransactionUrl = (transactionId: number,) => {




  return `/api/owner-accounting/transactions/${transactionId}/void`
}

/**
 * @summary Void Owner Transaction
 */
export const voidOwnerTransaction = async (transactionId: number,
    voidIn: VoidIn, options?: Parameters<typeof apiFetch>[1]): Promise<voidOwnerTransactionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<voidOwnerTransactionResponse>(getVoidOwnerTransactionUrl(transactionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(voidIn)
  }
);}





export const getVoidOwnerTransactionMutationKey = () => ['voidOwnerTransaction'] as const;

export const getVoidOwnerTransactionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voidOwnerTransaction>>, TError,VoidOwnerTransactionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof voidOwnerTransaction>>, TError,VoidOwnerTransactionMutationVariables, TContext> => {

const mutationKey = getVoidOwnerTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof voidOwnerTransaction>>, VoidOwnerTransactionMutationVariables> = (props) => {
          const {transactionId,data} = props ?? {};

          return  voidOwnerTransaction(transactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VoidOwnerTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof voidOwnerTransaction>>>
    export type VoidOwnerTransactionMutationBody = VoidIn
    export type VoidOwnerTransactionMutationError = HTTPValidationError
    export type VoidOwnerTransactionMutationVariables = {transactionId: number;data: VoidIn}

    /**
 * @summary Void Owner Transaction
 */
export const useVoidOwnerTransaction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voidOwnerTransaction>>, TError,VoidOwnerTransactionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof voidOwnerTransaction>>,
        TError,
        VoidOwnerTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getVoidOwnerTransactionMutationOptions(options), queryClient);
    }
